class DocumentChecklistItem {
    id = 0;
    document_checklist_id = null;
    global = false;
    rank_id = null;
    seniority = null;
    document_type_id = null;
    information = '';
    remarks = '';
    phase = 0;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default DocumentChecklistItem;
